export const JobTitleVI = {
    "jobTitle": {
        "title": {
            "header": "Chức vụ",
            "add": "Tạo mới chức vụ",
            "update": "Cập nhật chức vụ"
        },
       
    }
}